import { EDictionaryTypes, ETransactionDictionaryItemTypes } from 'models/dictionary';

export const ApiEndpoints = {
  LOG_IN: (): string => 'auth/login',
  LOG_OUT: (): string => 'auth/logout',
  REFRESH_AUTH_TOKEN: (): string => 'auth/refresh',
  ACCOUNT_CHANGE_PASSWORD: (): string => 'auth/password',
  GET_ROLES: (): string => 'role',
  GET_LIMITED_ROLES: (): string => 'role/limited',
  CREATE_ROLE: (): string => 'role',
  UPDATE_ROLE: (id: string): string => `role/${id}`,
  GET_ROLE: (id: string): string => `role/${id}`,
  DELETE_ROLE: (id: string): string => `role/${id}`,
  GET_ROLES_AMOUNT: () => 'role/count',
  GET_PERMISSIONS: (): string => 'permissions',
  GET_USERS: (): string => 'accounts',
  CREATE_USER: (): string => 'accounts',
  UPDATE_USER: (id: string): string => `accounts/${id}`,
  UPDATE_SELF_ACCOUNT: (): string => 'accounts/self',
  GET_USER: (id: string): string => `accounts/${id}`,
  DELETE_USER: (id: string): string => `accounts/${id}`,
  ACTIVATE_USER: (id: string): string => `accounts/${id}/active`,
  UNBAN_USER: (id: string): string => `auth/unban/${id}`,
  RESET_TWO_FA_OFFLINE_USER: (id: string): string => `/accounts/${id}/reset-two-fa-offline`,
  CHANGE_FORGOT_PASSWORD_RECAPTCHA: (query: string): string => `auth/recaptcha${query}`,
  FORGOT_PASSWORD: (): string => 'auth/password/forgot',
  CHANGE_PASSWORD: (queryParam: string): string => `auth/password/change${queryParam}`,
  GENERATE_PASSWORD: (): string => 'auth/password/generate',
  GENERATE_AUTH_CODE: (email: string): string => `auth/${email}/generate-authentication-code`,
  VERIFY_AUTH_CODE: (): string => 'auth/verify',
  VERIFY_OFFLINE_AUTH_CODE: (): string => 'auth/verify-offline',
  GET_TRUSTED_DEVICES: (): string => 'accounts/trusted-device',
  ADD_TRUSTED_DEVICE: (): string => 'accounts/trusted-device',
  FETCH_TRUSTED_DEVICES: (): string => 'accounts/trusted-device',
  DELETE_TRUSTED_DEVICE: (id: string) => `accounts/trusted-device/${id}`,
  CREATE_DICTIONARY_VALUE: (type: EDictionaryTypes): string => `dictionary/${type}`,
  UPDATE_DICTIONARY_VALUE: (id: string): string => `dictionary/${id}`,
  GET_DICTIONARY: (type: EDictionaryTypes): string => `dictionary/${type}/read-all`,
  GET_DICTIONARY_SEARCH: (type: EDictionaryTypes): string =>
    `dictionary/${type}/search-active`,
  GET_DICTIONARY_SEARCH_ALL: (type: EDictionaryTypes): string => `dictionary/${type}/search`,
  GET_DICTIONARY_LIKE: (type: EDictionaryTypes): string =>
    `dictionary/${type}/read-all-active/search`,
  GET_DICTIONARY_LANGUAGES: (type: EDictionaryTypes): string => `dictionary/${type}/languages`,
  GET_DICTIONARY_DETAIL: (type: EDictionaryTypes): string => `dictionary/${type}`,
  GET_DICTIONARIES: (): string => 'dictionary',
  GET_DICTIONARY_BY_ID: (id: string): string => `dictionary/${id}/read`,
  GET_DICTIONARY_USAGE: (id: string): string => `dictionary/${id}/usage`,
  GET_DICTIONARIES_BY_IDS: (): string => 'dictionary/read-by-ids',
  GET_DICTIONARY_TYPE_HASHES: (): string => 'dictionary/hashes-by-type',
  GET_DICTIONARY_TRANSLATION_TEMPLATE: (): string => 'dictionary/generate-template',
  IMPORT_DICTIONARY_TRANSLATIONS: (): string => 'dictionary/import-translations',
  GET_LICENCE_DETAILS: (): string => 'licence/details',
  REDEEM_LICENCE_KEY: (): string => 'licence/redeem',
  GET_LICENCE_BASIC_INFO: (): string => 'licence/basic-info',
  GET_INITIAL_TRANSACTION_DICTIONARY: (itemType: ETransactionDictionaryItemTypes) =>
    `dictionary/transaction/initial-types?itemType=${itemType}`,
  GET_MIDDLE_TRANSACTION_DICTIONARY: (itemType: ETransactionDictionaryItemTypes) =>
    `dictionary/transaction/middle-types?itemType=${itemType}`,
  GET_POSSIBLE_TRANSACTION_TYPE: () => 'transaction/middle',
  GET_POSSIBLE_TRANSACTION_TYPE_FOR_GROUP: () => 'transaction/middle-for-group',
  GET_LEGAL_ENTITY: (id: string): string => `individuals/${id}`,
  GET_LEGAL_ENTITIES: (): string => 'individuals/search',
  GET_LEGAL_ENTITY_FIREARMS: (): string => 'legal/firearms/search',
  GET_LEGAL_ENTITY_ANCILLARIES: (): string => 'legal/ancillaries/search',
  GET_LEGAL_ENTITY_ANCILLARY_GROUP: (id: string): string => `/legal/${id}/groups/ancillaries`,
  GET_LEGAL_ENTITY_ANCILLARY_GROUP_ANCILLARIES: (id: string, groupId: string): string =>
    `/legal/${id}/groups/${groupId}/ancillaries`,
  DELETE_LE_GROUP_ANCILLARY: (id: string, groupId: string, ancillaryId: string): string =>
    `/legal/${id}/groups/${groupId}/ancillaries/${ancillaryId}`,
  CREATE_LEGAL_ENTITY_ANCILLARY_GROUP: (id: string): string =>
    `/legal/${id}/groups/ancillaries`,
  DELETE_LEGAL_ENTITY_ANCILLARY_GROUP: (groupId: string, LEId: string): string =>
    `/legal/${LEId}/groups/ancillaries/${groupId}`,
  GET_LEGAL_ENTITY_GROUPS: (id: string): string => `legal/${id}/groups`,
  GET_LEGAL_ENTITY_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/${groupId}`,
  GET_LEGAL_ENTITY_GROUP_FIREARMS: (leId: string, groupId: string): string =>
    `legal/${leId}/groups/${groupId}/firearms`,
  CREATE_LEGAL_ENTITY: (): string => 'individuals',
  UPDATE_LEGAL_ENTITY: (id: string): string => `individuals/${id}`,
  DELETE_LEGAL_ENTITY: (id: string): string => `individuals/${id}`,
  GET_LEGAL_ENTITY_ADDRESS_READ_ASSETS: (id: string, addressId: string): string =>
    `legal/${id}/address/${addressId}/read-assets`,
  GET_ORGANIZATION_LEGAL_ENTITIES: (): string => 'organizations/search',
  GET_ORG_LEGAL_ENTITY: (id: string): string => `organizations/${id}`,
  CREATE_ORG_LEGAL_ENTITY: (): string => 'organizations',
  UPDATE_ORG_LEGAL_ENTITY: (id: string): string => `organizations/${id}`,
  DELETE_ORG_LEGAL_ENTITY: (id: string): string => `organizations/${id}`,
  CREATE_LEGAL_ENTITY_COMMENT: (id: string): string => `legal/${id}/comments`,
  GET_LEGAL_ENTITY_COMMENTS: (id: string): string => `legal/${id}/comments`,
  GET_LEGAL_TYPE: (id: string): string => `legal/${id}`,
  GET_LEGAL_ENTITY_COMMENT: (id: string, commentId: string): string =>
    `legal/${id}/comments/${commentId}`,
  DELETE_COMMENT: (id: string): string => `comment/${id}/visible`,
  GET_ACCOUNT: (id: string): string => `accounts/${id}`,
  GET_SELF_ACCOUNT: (): string => 'accounts/self',
  GET_LEGAL_ENTITY_ADDRESSES: (id: string): string => `legal/${id}/address`,
  GET_LEGAL_ENTITY_STORAGE_ADDRESSES: (id: string): string => `legal/${id}/address/storage`,
  GET_LEGAL_ENTITY_ADDRESS: (id: string, addressId: string): string =>
    `legal/${id}/address/${addressId}`,
  CREATE_LEGAL_ENTITY_ADDRESS: (id: string): string => `legal/${id}/address`,
  SET_LEGAL_ENTITY_DEFAULT_ADDRESS: (id: string, addressId: string): string =>
    `legal/${id}/address/${addressId}/default`,
  GEOLOCATION_SEARCH_BY_ADDRESS: (): string => 'geolocation/search-by-address',
  GEOLOCATION_SEARCH_BY_TEXT: (): string => 'geolocation/search-by-text',
  GEOLOCATION_SEARCH_BY_COORDS: (): string => 'geolocation/search-by-coords',
  GEOLOCATION_TILE: (z: number, x: number, y: number): string =>
    `geolocation/tiles/${z}/${x}/${y}`,
  UPDATE_LEGAL_ENTITY_ADDRESS: (id: string, addressId: string): string =>
    `legal/${id}/address/${addressId}`,
  GET_LEGAL_ENTITY_ADDRESS_IS_LINKED_TO_LICENCE: (
    legalUniqueId: string,
    addressId: string,
  ): string => `legal/${legalUniqueId}/address/${addressId}/is-linked-with-active-licence`,
  DELETE_LEGAL_ENTITY_ADDRESS: (id: string, addressId: string): string =>
    `legal/${id}/address/${addressId}`,
  CREATE_LEGAL_ENTITY_CONTACT: (id: string): string => `legal/${id}/contacts`,
  UPDATE_LEGAL_ENTITY_CONTACT: (id: string, contactId: string): string =>
    `legal/${id}/contacts/${contactId}`,
  GET_LEGAL_ENTITY_CONTACTS: (id: string): string => `legal/${id}/contacts`,
  GET_LEGAL_ENTITY_LATEST_CONTACT: (id: string): string => `legal/${id}/contacts/read-latest`,
  GET_LEGAL_ENTITY_CONTACT: (id: string, commentId: string): string =>
    `legal/${id}/contacts/${commentId}`,
  DELETE_LEGAL_ENTITY_CONTACT: (id: string, contactId: string): string =>
    `legal/${id}/contacts/${contactId}`,
  GET_LEGAL_ENTITY_PREVIOUS_NAME: (leId: string): string =>
    `legal/previous-name/${leId}/read-all`,
  GET_LEGAL_ENTITY_PREVIOUS_NAME_DETAIL: (id: string): string => `legal/previous-name/${id}`,
  CREATE_LEGAL_ENTITY_PREVIOUS_NAME: (): string => 'legal/previous-name',
  UPDATE_LEGAL_ENTITY_PREVIOUS_NAME: (id: string): string => `legal/previous-name/${id}`,
  DELETE_LEGAL_ENTITY_PREVIOUS_NAME: (id: string): string => `legal/previous-name/${id}`,
  CREATE_LEGAL_ENTITY_GROUP: (id: string): string => `legal/${id}/groups`,
  UPDATE_LEGAL_ENTITY_ANCILLARY_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/ancillaries/${groupId}`,
  UPDATE_LEGAL_ENTITY_FIREARM_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/${groupId}`,
  UPDATE_LEGAL_ENTITY_ADD_TO_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/${groupId}/ancillaries`,
  DELETE_LEGAL_ENTITY_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/${groupId}`,
  GET_LEGAL_ENTITY_ANCILLARIES_GROUP_DETAIL: (id: string, groupId: string): string =>
    `legal/${id}/groups/ancillaries/${groupId}`,
  GET_LEGAL_ENTITY_ANCILLARIES_FROM_GROUP: (groupId: string): string =>
    `ancillary-group/${groupId}`,
  DELETE_LEGAL_ENTITY_ANCILLARIES_GROUP: (id: string, groupId: string): string =>
    `legal/${id}/groups/ancillaries/${groupId}`,
  ASSIGN_LE: (id: string): string => `legal/${id}/accounts`,
  DELETE_ASSIGN_LE: (id: string): string => `legal/${id}/accounts`,
  DEACTIVATE_ORGANIZATION_LE: (id: string): string => `organizations/deactivate/${id}`,
  ACTIVATE_ORGANIZATION_LE: (id: string): string => `organizations/activate/${id}`,
  DEACTIVATE_INDIVIDUAL_LE: (id: string): string => `individuals/deactivate/${id}`,
  ACTIVATE_INDIVIDUAL_LE: (id: string): string => `individuals/activate/${id}`,
  GET_FIREARMS: (): string => 'firearm/search',
  GET_FIREARMS_FOR_MAP: (): string => 'firearm/search-for-map',
  GET_FIREARMS_MAP_CLUSTERED: (): string => 'firearm/search-map-clustered',
  GET_FIREARM: (id: string): string => `firearm/${id}`,
  UPDATE_FIREARM_CUSTOM_FIELDS: (id: string): string => `firearm/${id}/custom-field`,
  GET_FRT: (): string => 'FRT/search',
  GET_FRT_SPECIFICATIONS: (id: string): string => `FRT/${id}/specifications`,
  GET_FRT_NOTES: (id: string): string => `FRT/${id}/notes`,
  GET_FRT_CHECK_IS_USED: (id: string): string => `frt-local/${id}/check-is-used`,
  GET_FRT_DETAILS: (id: string): string => `FRT/${id}`,
  ADD_FRT_LOCAL: (): string => 'frt-local',
  UPDATE_FRT_LOCAL: (frtId: string): string => `frt-local/${frtId}`,
  CREATE_FRT_LOCAL_SPECIFICATION: (id: string) => `/frt-local/${id}/specification`,
  UPDATE_FRT_LOCAL_SPECIFICATION: (id: string, specificationId: string) =>
    `/frt-local/${id}/specification/${specificationId}`,
  GET_FIREARM_LICENCES: (): string => `firearm/weapon-licence/search`,
  GET_FIREARM_TRANSACTIONS: (id: string): string => `firearm/${id}/transactions`,
  DISABLE_FIREARM: (id: string): string => `firearm/${id}/disable`,
  GET_FIREARM_ATTACHMENTS: (id: string): string => `firearm/${id}/attachments`,
  GET_FIREARM_USED_TRANSACTION_TYPES: (id: string): string =>
    `firearm/${id}/used-transaction-types`,
  GET_FIREARM_COMMENTS: (id: string): string => `firearm/${id}/comments`,
  GET_FIREARM_LAST_TRANSACTION_UNIQUE_ID: (firearmUniqueId: string): string =>
    `transaction/${firearmUniqueId}/last-unique-id`,
  GET_GROUP_LAST_TRANSACTION_UNIQUE_ID: (groupUniqueId: string): string =>
    `transaction/${groupUniqueId}/last-unique-id/for-group`,
  GET_FIREARM_COMMENT: (id: string, commentId: string): string =>
    `firearm/${id}/comments/${commentId}`,
  CREATE_FIREARM_COMMENT: (id: string): string => `firearm/${id}/comments`,
  DOWNLOAD_FIREARM_ATTACHMENT: (firearmId: string, attachmentId: string) =>
    `firearm/${firearmId}/attachments/${attachmentId}`,
  ADD_FIREARM_ATTACHMENT: (firearmId: string): string => `firearm/${firearmId}/attachments`,
  ADD_FIREARM_ATTACHMENT_IN_TRANSACTION: (firearmId: string): string =>
    `firearm/${firearmId}/attachment-in-transaction`,
  DELETE_FIREARM_ATTACHMENT: (firearmId: string, attachmentId: string): string =>
    `firearm/${firearmId}/attachments/${attachmentId}`,
  EXPORT_REGISTERED_FIREARMS_CSV: (): string => 'reports/firearm/export',
  EXPORT_FIREARM_TRANSACTIONS_CSV: (firearmId: string): string =>
    `reports/firearm/${firearmId}/transactions/export`,
  DELETE_LE_GROUP_FIREARM: (id: string, groupId: string, firearmId: string): string =>
    `legal/${id}/groups/${groupId}/firearms/${firearmId}`,
  CREATE_LE_GROUP_FIREARM: (id: string, groupId: string): string =>
    `legal/${id}/groups/${groupId}/firearms`,
  GET_LEGAL_ENTITY_LICENCE_AUTHORITIES: (id: string): string =>
    `legal/licence-authority/${id}`,
  GET_LANGUAGES: (): string => 'languages',
  GET_TRANSLATIONS: (): string => 'messages',
  EXPORT_ILE_CSV: (): string => 'reports/individual/export',
  EXPORT_OLE_CSV: (): string => 'reports/organization/export',
  VALIDATE_RESET_PASSWORD_LINK: (): string => 'auth/password/validateLink',
  GET_SEARCH_FILTER: (): string => 'search-filter',
  GET_SEARCH_FILTER_BY_TYPE: (type: string): string => `search-filter/by-type/${type}`,
  GET_SEARCH_FILTER_BY_ID: (id: string): string => `search-filter/${id}`,
  DELETE_SEARCH_FILTER: (id: string): string => `/search-filter/${id}`,
  CREATE_SEARCH_FILTER_INDIVIDUAL: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/individual?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_ORGANIZATION: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/organization?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_FIREARM: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/firearm?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_LICENCE_CONFIGURATION: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/licence-configuration?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_TRANSACTION: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/transaction?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_LICENCE: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/weapon-licence?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  CREATE_SEARCH_FILTER_ACCESSORY: (
    name: string,
    emailNotificationEnabled: boolean,
    notificationEnabled: boolean,
  ): string =>
    `search-filter/ancillaries?name=${name}&emailNotificationEnabled=${emailNotificationEnabled}&notificationEnabled=${notificationEnabled}`,
  TOGGLE_SEARCH_FILTER_NOTIFICATION: (id: string, value: boolean): string =>
    `/search-filter/${id}/toggle-email-notification?value=${value}`,
  GET_FIREARMS_AVAILABLE_FOR_GROUP: (id: string): string =>
    `legal/${id}/groups/firearms/search-to-add`,
  EXPORT_TRANSACTIONS: (): string => '/reports/transactions/export',
  CREATE_INITIAL_TRANSACTION: (): string => 'transaction/initial',
  CREATE_ANCILLARY_INITIAL_TRANSACTION: (): string => 'transaction/ancillary/initial',
  CREATE_MIDDLE_TRANSACTION_FOR_GROUP: (): string => 'transaction/middle-for-group',
  CREATE_MIDDLE_TRANSACTION: (): string => 'transaction/middle',
  GET_GLOBAL_PROPERTIES: (): string => 'global-property',
  GET_TRANSACTION: (): string => 'transaction',
  GET_PREVIOUS_TRANSACTION_LOCATION: (id: string): string =>
    `transaction/${id}/previous-location`,
  GET_TRANSACTION_DETAILS: (id: string, onlyVisible: boolean): string =>
    `transaction/${id}?onlyVisible=${onlyVisible}`,
  GET_TRANSACTION_DETAILS_FIREARMS: (id: string): string => `transaction/${id}/firearms`,
  GET_TRANSACTION_DETAILS_ANCILLARIES: (id: string): string => `transaction/${id}/ancillaries`,
  GET_TRANSACTION_DETAILS_MARKINGS: (id: string): string => `transaction/${id}/markings`,
  GET_TRANSACTION_DETAILS_COMMENTS: (id: string): string => `transaction/${id}/comments`,
  CANCEL_FIREARM_TRANSACTION: (id: string): string => `transaction/${id}`,
  CANCEL_ANCILLARY_TRANSACTION: (id: string): string => `transaction/ancillary/${id}`,
  CANCEL_TRANSACTION_FOR_FIREARM_GROUP: (id: string): string => `transaction/${id}/for-group`,
  CANCEL_TRANSACTION_FOR_ANCILLARY_GROUP: (id: string): string =>
    `transaction/ancillary/${id}/for-group`,
  CREATE_COMMENT_IN_TRANSACTION: (id: string): string => `transaction/${id}/comments`,
  GET_COMMENT_IN_TRANSACTION: (id: string, commentId: string): string =>
    `transaction/${id}/comments/${commentId}`,
  GET_FIREARM_LAST_TRANSACTION: (id: string) => `transaction/${id}/last`,
  IS_GROUP_TRANSACTION_DISCARDABLE: (id: string) => `transaction/${id}/is-discardable`,
  IS_ANCILLARY_GROUP_TRANSACTION_DISCARDABLE: (id: string) =>
    `transaction/ancillary/${id}/is-discardable`,
  GET_ANCILLARY_LAST_TRANSACTION: (id: string) => `transaction/ancillary/${id}/last`,
  GET_GROUP_LAST_TRANSACTION: (id: string) => `transaction/${id}/last-for-group`,
  GET_ANCILLARY_GROUP_LAST_TRANSACTION: (id: string) =>
    `transaction/ancillary/${id}/last-for-group`,
  GET_FIREARM_GROUP_DETAILS: (id: string) => `/firearm-group/${id}`,
  IS_TRANSACTION_LAST: (id: string) => `transaction/${id}/is-last`,
  IS_TRANSACTION_DELETED: (id: string) => `transaction/${id}/is-deleted`,
  GENERATE_FIREARMS_TEMPLATE: () => 'firearm/generate-template',
  GENERATE_ANCILLARIES_TEMPLATE: () => 'ancillaries/generate-template',
  GET_ASSIGNED_LEGALS_IDS_TO_USER: (id: string): string => `accounts/${id}/assigned-legals`,
  GET_ASSIGNED_SELF_LEGALS_IDS_TO_USER: (): string => 'accounts/assigned-self-legals',
  GET_ASSIGNED_LEGALS_TO_USER: (): string => 'legal',
  GET_NOTIFICATIONS: (): string => 'search-filter/notification',
  GET_NOTIFICATION: (id: string): string => `search-filter/notification/${id}`,
  GET_NOTIFICATION_UNREAD_COUNTER: (): string => 'search-filter/notification/unread-count',
  DELETE_NOTIFICATIONS: (query: string): string => `search-filter/notification${query}`,
  MARK_AS_READ_NOTIFICATIONS: (query: string): string => `search-filter/notification${query}`,
  DASHBOARD_FIREARMS_LEGALITY: (): string => 'dashboard/chart/firearms-legality',
  DASHBOARD_ANCILLARIES_TYPES: (): string => 'dashboard/chart/ancillaries',
  DASHBOARD_TRANSACTIONS_TYPES: (): string => 'dashboard/chart/transactions',
  DASHBOARD_LEGAL_ENTITIES: (): string => 'dashboard/chart/legal-entities',
  DASHBOARD_FIREARMS_STATES: (): string => 'dashboard/chart/firearms-states',
  DASHBOARD_GLOBAL_SEARCH: (category: string): string => `dashboard/global-search/${category}`,
  CREATE_CUSTOM_FIELD: (): string => 'custom-field',
  GET_CUSTOM_FIELDS: (): string => 'custom-field/read-all',
  GET_CUSTOM_FIELD: (id: string) => `custom-field/${id}`,
  CHANGE_CUSTOM_FIELD_STATUS: (id: string) => `custom-field/${id}/change-status`,
  DELETE_CUSTOM_FIELD: (id: string) => `custom-field/${id}`,
  GET_CUSTOM_FIELD_PROPERTIES: () => 'custom-field/properties',
  UPDATE_CUSTOM_FIELD: (id: string): string => `custom-field/${id}`,
  GET_CUSTOM_FIELD_BY_OBJECT_TYPE: (): string => 'custom-field/read-all/object-type',
  GET_ANCILLARIES: (): string => 'ancillaries/search',
  GET_ANCILLARIES_FOR_MAP: (): string => 'ancillaries/search-for-map',
  GET_ANCILLARIES_MAP_CLUSTERED: (): string => 'ancillaries/search-map-clustered',
  GET_ANCILLARIES_BY_GROUP_ID_SEARCH: (LEId: string, id: string): string =>
    `/legal/${LEId}/groups/ancillaries/search-to-add/by-group/${id}`,
  GET_ANCILLARIES_GROUP_SEARCH: (LEId: string): string =>
    `/legal/${LEId}/groups/ancillaries/search-to-add/by-ancillary`,
  GET_ANCILLARIES_BY_GROUP: (LEId: string, id: string): string =>
    `/legal/${LEId}/groups/${id}/ancillaries`,
  GET_ANCILLARY_GROUP_TRANSACTION_TYPES: (): string =>
    '/transaction/ancillary/middle-for-group',
  GET_ANCILLARY_GROUP_TRANSACTION_VALIDATE_TYPE: (): string =>
    'transaction/ancillary/validate',
  GET_ANCILLARIES_REFERENCE_TABLE: (): string => 'art/accessories/search',
  GET_ANCILLARIES_ACCESSORY: (id: string): string => `/art/accessories/${id}`,
  CREATE_ANCILLARIES_ACCESSORY: (): string => '/art/accessories',
  UPDATE_ANCILLARIES_ACCESSORY: (id: string): string => `/art/accessories/${id}`,
  GET_AMMUNITION_REFERENCE_TABLE: (): string => 'art/ammunitions/search',
  CREATE_AMMUNITION: (): string => '/art/ammunitions',
  GET_ANCILLARIES_AMMUNITION: (id: string): string => `/art/ammunitions/${id}`,
  UPDATE_ANCILLARIES_AMMUNITION: (id: string): string => `/art/ammunitions/${id}`,
  GET_ANCILLARY: (id: string): string => `ancillaries/${id}`,
  GET_ANCILLARY_TRANSATIONS: (id: string): string =>
    `/transaction/ancillary/${id}/transactions`,
  GET_ANCILLARY_COMMENTS: (id: string): string => `ancillaries/comments/${id}`,
  GET_ANCILLARY_COMMENT: (id: string, commentId: string): string =>
    `/ancillaries/comments/${id}/${commentId}`,
  GET_POSSIBLE_ANCILLARIES_TRANSACTION_TYPE: () => 'transaction/middle/ancillary',
  GET_ANCILLARY_GROUP_LAST_TRANSACTION_UNIQUE_ID: (groupUniqueId: string) =>
    `transaction/ancillary/${groupUniqueId}/last-unique-id/for-group`,
  GET_ANCILLARY_LAST_TRANSACTION_UNIQUE_ID: (ancillaryUniqueId: string) =>
    `transaction/ancillary/${ancillaryUniqueId}/last-unique-id`,
  CREATE_ANCILLARY_MIDDLE_TRANSACTION: () => 'transaction/ancillary/middle',
  CREATE_ANCILLARY_GROUP_MIDDLE_TRANSACTION: () => 'transaction/ancillary/middle-for-group',
  DISABLE_ANCILLARY: (id: string) => `transaction/ancillary/${id}/disable`,
  CREATE_ACCESSORY_COMMENT: (id: string): string => `ancillaries/comments/${id}`,
  GET_ANCILLARY_ATTACHMENTS: (id: string): string => `ancillary/${id}/attachments`,
  GET_ACCESSORY_ATTACHMENTS_USED_TRANSACTION_TYPES: (id: string): string =>
    `transaction/ancillary/${id}/used-transaction-types`,
  ADD_ACCESSORY_ATTACHMENTS: (id: string): string => `ancillary/${id}/attachments`,
  ADD_ACCESSORY_ATTACHMENTS_IN_TRANSACTION: (id: string): string =>
    `/transaction/ancillary/${id}/attachment-in-transaction`,
  GET_ANCILLARY_ATTACHMENT: (ancillaryId: string, attachmentId: string): string =>
    `ancillary/${ancillaryId}/attachments/${attachmentId}`,
  DLETE_ANCILLARY_ATTACHMENT: (ancillaryId: string, attachmentId: string): string =>
    `/ancillary/${ancillaryId}/attachments/${attachmentId}`,
  EXPORT_ANCILLARY_CSV: (): string => 'reports/ancillaries/export',
  UPDATE_ANCILLARY_CUSTOM_FIELDS: (id: string): string => `ancillaries/${id}/custom-field`,
  GET_DATE_TIME_SETUP: () => 'global-property/date_format',
  GET_TIME_ZONE: () => 'system-configuration-info/time-zone',
  GET_MINUTES_IN_BAN: () => 'global-property/minutes_in_ban',
  GET_ATTEMPTS_TO_BLOCK: () => 'global-property/attempts_to_block',
  GET_METHOD_AUTH: () => 'global-property/authorize-option',
  GET_TRUSTED_DEVICE_OPTIONS: () => 'accounts/trusted-device/options-enabled',
  UPDATE_TWO_FA: () => 'global-property/authorize-option',
  UPDATE_MINUTES_IN_BAN: () => 'global-property/minutes-in-ban',
  UPDATE_ATTEMPTS_TO_BLOCK: () => 'global-property/attempts-to-block',
  UPDATE_TRUSTED_DEVICE_OPTIONS: () => 'accounts/trusted-device/options',
  GET_TRUSTED_DEVICE_OPTIONS_LIST: () => 'accounts/trusted-device/options',
  GET_ENABLED_TRUSTED_DEVICE_OPTIONS_LIST: () => 'accounts/trusted-device/options-enabled',
  UPDATE_DATE_TIME_SETUP: () => 'global-property/date-format',
  GET_COMPONENTS_REFERENCE_TABLE: (): string => 'art/components/search',
  CREATE_COMPONENT: (): string => '/art/components',
  GET_ANCILLARIES_COMPONENT: (id: string): string => `/art/components/${id}`,
  UPDATE_ANCILLARIES_COMPONENT: (id: string): string => `/art/components/${id}`,
  GET_AUDIT_LOG: (): string => '/auditlog/search',
  GET_AUDIT_LOG_ITEM: (id: string) => `/auditlog/${id}`,
  EXPORT_AUDIT_LOG: (): string => '/reports/auditlog/export',
  UPDATE_NOTIFICATION_SETUP: (): string => 'global-property/notification-time-interval',
  UPDATE_IARMS_SETUP: (): string => 'global-property/iarms-raports-enabled',
  UPDATE_ETRACE_SETUP: (): string => 'global-property/etrace-raports-enabled',
  UPDATE_CURRENCY: (): string => 'global-property/currency',
  UPDATE_MEASUREMENT: (): string => 'global-property/measurement-unit',
  GET_NOTIFICATION_SETUP: (): string => 'global-property/notification_time_interval',
  GET_ETRACE_SETUP: (): string => 'global-property/etrace_reports_enabled',
  GET_CURRENCY: (): string => 'global-property/currency',
  GET_MEASUREMENT: (): string => 'global-property/measurement_unit',
  GET_OPTIONAL_FIELDS: (): string => 'optional-field',
  UPDATE_OPTIONAL_FIELDS: (): string => 'optional-field',
  GET_IARMS_SETUP: (): string => 'global-property/iarms_reports_enabled',
  GET_GLOBAL_PROPERTY_BY_KEY: (key: string): string => `/global-property/${key}`,
  UPDATE_LICENCE_RENEWAL_ALLOWED_DAYS_BEFORE_EXPIRATION: (): string =>
    'global-property/licence-renewal-allowed-days-before-expiration',
  UPDATE_LICENCE_EXPIRATION_NOTIFICATION_DAYS_BEFORE: (): string =>
    'global-property/licence-expiration-notification-days-before',
  GET_API_KEYS: () => '/apikey/read-all',
  CREATE_API_KEY: () => '/apikey',
  GET_API_KEY: (id: string) => `/apikey/${id}`,
  UPDATE_API_KEY: (id: string) => `/apikey/${id}`,
  CHANGE_STATUS_API_KEY: (id: string) => `/apikey/change-status/${id}`,
  GET_API_KEY_HISTORY: (id: string) => `/apikey/${id}/read-history`,
  DELETE_API_KEY: (id: string) => `/apikey/${id}`,
  SEND_EMAIL_API_KEY: (id: string) => `/apikey/${id}/send-email`,
  UPDATE_LOGIN_SCREEN: () => '/login-screen-setup',
  GET_LOGIN_SCREEN: () => '/login-screen-setup/read-all',
  CREATE_LICENCE_TEMPLATE: () => '/weapon-licence-template',
  MANAGE_LICENCE_TEMPLATE: () => '/weapon-licence-template',
  GET_LICENCE_TEMPLATE: (id: string) => `/weapon-licence-template/${id}`,
  DELETE_LICENCE_TEMPLATE: (id: string) => `/weapon-licence-template/${id}`,
  DEACTIVATE_LICENCE_TEMPLATE_STATUS: (id: string) =>
    `/weapon-licence-template/${id}/deactivate`,
  ACTIVATE_LICENCE_TEMPLATE_STATUS: (id: string) => `/weapon-licence-template/${id}/activate`,
  GET_LICENCE_TEMPLATES: () => '/weapon-licence-template/search',
  GET_LICENCE_TEMPLATES_FOR_LE: () => '/weapon-licence-template/read-for-legal',
  GET_WEAPON_LICENCES_FOR_LE: (): string => '/weapon-licence/read-for-legal',
  GET_WEAPON_LICENCE_DETAILS: (id: string): string => `/weapon-licence/${id}`,
  GET_WEAPON_LICENCE_HAS_SUSPENDED_PARENT: (id: string): string =>
    `/weapon-licence/${id}/has-suspended-parent`,
  GET_WEAPON_LICENCE_MISMATCHING: (id: string): string =>
    `/weapon-licence/${id}/mismatching-legal-entity-data`,

  CREATE_APPLICATION_PROCCESSES_TASK: (): string =>
    '/weapon-licence-template/application-process/task',
  DELETE_APPLICATION_PROCCESSES_TASK: (id: string): string =>
    `/weapon-licence-template/application-process/task/${id}`,
  GET_APPLICATION_PROCCESSES_TASKS: (id: string): string =>
    `weapon-licence-template/application-process/task/search/${id}`,

  CREATE_APPLICATION_PROCCESSES_INTELIGENCE_REPORT: (): string =>
    'weapon-licence-template/application-process/intelligence-reports',
  UPDATE_APPLICATION_PROCCESSES_INTELIGENCE_REPORT: (id: string): string =>
    `weapon-licence-template/application-process/intelligence-reports/${id}`,
  DELETE_APPLICATION_PROCCESSES_INTELIGENCE_REPORT: (id: string): string =>
    `weapon-licence-template/application-process/intelligence-reports/${id}`,
  GET_APPLICATION_PROCCESSES_INTELIGENCE_REPORTS: (id: string): string =>
    `weapon-licence-template/application-process/intelligence-reports/${id}`,

  UPDATE_PRINTOUT_SETTINGS: (id: string) => `weapon-licence-template/${id}/printout-settings`,
  CREATE_PRINTOUT_SETTINGS: (id: string) => `weapon-licence-template/${id}/printout-settings`,
  GET_PRINTOUT_SETTINGS_AVAILABLE_FIELDS: (id: string) =>
    `weapon-licence-template/${id}/printout-settings/available-fields`,

  CREATE_APPLICATION_PROCCESSES_DOCUMENT: (): string =>
    '/weapon-licence-template/application-process/document',
  DELETE_APPLICATION_PROCCESSES_DOCUMENT: (id: string): string =>
    `/weapon-licence-template/application-process/document/${id}`,
  GET_APPLICATION_PROCCESSES_DOCUMENTS: (id: string): string =>
    `weapon-licence-template/application-process/document/search/${id}`,

  GET_LICENCE_TEMPLATE_APPLICATION_PROCESS_TYPES: (id: string) =>
    `/weapon-licence-template/application-process/${id}/available-process-types`,

  GET_LICENCE_TEMPLATE_APPLICATION_PROCCESSES: (id: string) =>
    `/weapon-licence-template/application-process/for-licence-template/${id}`,
  GET_LICENCE_TEMPLATE_APPLICATION_PROCCESS: (id: string) =>
    `/weapon-licence-template/application-process/${id}`,

  CREATE_LICENCE_TEMPLATE_APPLICATION_PROCCESS: () =>
    '/weapon-licence-template/application-process',
  UPDATE_LICENCE_TEMPLATE_APPLICATION_PROCCESS_SETTINGS: (id: string) =>
    `/weapon-licence-template/application-process/${id}/settings`,
  UPDATE_LICENCE_TEMPLATE_APPLICATION_PROCCESS_PRICE: (id: string) =>
    `/weapon-licence-template/application-process/${id}/price`,
  DELETE_LICENCE_TEMPLATE_APPLICATION_PROCCESS: (id: string) =>
    `/weapon-licence-template/application-process/${id}`,

  ACTIVATE_LICENCE_TEMPLATE_APPLICATION_PROCCESS: (id: string) =>
    `/weapon-licence-template/application-process/${id}/activate`,
  DEACTIVATE_LICENCE_TEMPLATE_APPLICATION_PROCCESS: (id: string) =>
    `/weapon-licence-template/application-process/${id}/deactivate`,

  GET_LICENCE_ATTACHMENTS: (weaponLicenceUniqueId: string): string =>
    `weapon-licence/${weaponLicenceUniqueId}/attachments`,
  GET_LICENCE_ATTACHMENT_FILE: (
    weaponLicenceUniqueId: string,
    attachmentUniqueId: string,
  ): string =>
    `/weapon-licence/${weaponLicenceUniqueId}/attachments/download/${attachmentUniqueId}`,
  GET_LICENCE_ATTACHMENT_FILE_VIEW: (
    weaponLicenceUniqueId: string,
    attachmentUniqueId: string,
  ): string =>
    `/weapon-licence/${weaponLicenceUniqueId}/attachments/preview/${attachmentUniqueId}`,
  GET_LICENCE_HISTORY: (licenceUniqueId: string): string =>
    `/weapon-licence/history/${licenceUniqueId}`,
  GET_LICENCE_HISTORY_DETAILS: (historyUniqueId: string): string =>
    `/weapon-licence/history/details/${historyUniqueId}`,
  GET_WEAPON_LICENSE_SCHEDULED: () => '/weapon-licence/scheduled-licence-data',
  CREATE_WEAPON_LICENCE: () => '/weapon-licence',
  VARY_WEAPON_LICENCE: (id: string) => `/weapon-licence/${id}/vary`,
  RENEW_WEAPON_LICENCE: (id: string) => `/weapon-licence/${id}/renew`,
  GET_WEAPON_LICENSES: () => 'weapon-licence/search',
  GET_PRINTOUTS: () => 'weapon-licence-print/search',
  GET_BATCHES: () => 'weapon-licence-print-batch/search',
  GET_WEAPON_LICENCE_PRINT: (uniqueId: string) => `weapon-licence-print/${uniqueId}`,
  GET_WEAPON_LICENCE_PRINT_BATCH: (uniqueId: string) =>
    `weapon-licence-print-batch/${uniqueId}`,
  SEARCH_WEAPON_LICENCE_PRINT_BATCH_PRINTOUTS: (uniqueId: string) =>
    `weapon-licence-print-batch/${uniqueId}/printouts/search`,
  GET_WEAPON_LICENCE_PRINT_BATCH_HISTORY: (uniqueId: string) =>
    `weapon-licence-print-batch/${uniqueId}/history`,
  CANCEL_AND_ENQUEUE_AGAIN_WEAPON_LICENCE_PRINT_BATCH: (uniqueId: string) =>
    `weapon-licence-print-batch/${uniqueId}/cancel-and-enqueue-again`,
  GET_LICENCE_PRINTOUTS_HISTORY: () => 'weapon-licence-print/history/search',
  GET_PRINTOUT_HISTORY: (uniqueId: string) => `weapon-licence-print/${uniqueId}/history`,
  GET_LICENCE_PRINT_AVAILABILITY: (id: string) => `weapon-licence-print/${id}/can-be-printed`,
  SEARCH_CASE_LICENCES_FOR_REPRINT: (id: string) =>
    `weapon-licence-print/${id}/reprint/search`,
  CANCEL_LICENCE_PRINT_REQUEST: (id: string) => `weapon-licence-print/cancel/${id}`,
  ENQUEUE_LICENCE_PRINT: (id: string) => `weapon-licence-print/enqueue/${id}`,
  GET_WEAPON_LICENSES_FIREARMS_SEARCH: () => 'weapon-licence/firearm/search-for-link',
  WEAPON_LICENSES_FIREARMS_TO_LINK: () => 'weapon-licence/firearm',
  GET_LICENCE_WEAPON_FIREARMS: (id: string): string => `weapon-licence/firearm/${id}`,
  GET_LICENCE_READ_LIMIT_FIREARMS: (id: string): string =>
    `weapon-licence/firearm/${id}/limits`,
  REVOKE_WEAPON_LICENCE: (uniqueId: string): string => `weapon-licence/${uniqueId}/revoke`,
  CANCEL_WEAPON_LICENCE: (uniqueId: string): string => `weapon-licence/${uniqueId}/cancel`,
  SUSPEND_WEAPON_LICENCE: (uniqueId: string): string => `weapon-licence/${uniqueId}/suspend`,
  SURRENDER_WEAPON_LICENCE: (uniqueId: string): string =>
    `weapon-licence/${uniqueId}/surrender`,
  REACTIVATE_WEAPON_LICENCE: (uniqueId: string): string =>
    `weapon-licence/${uniqueId}/reactivate`,
  EXPORT_LICENCE_CSV: (): string => 'reports/licence/export',
  GET_CASES: () => 'weapon-licence-cases/search',
  GET_CASES_FOR_LE: (id: string): string => `/weapon-licence-cases/read-for-legal/${id}`,
  GET_CASE: (id: string): string => `/weapon-licence-cases/${id}`,
  GET_CASE_RENEW: (id: string): string => `weapon-licence-cases/renew-form/${id}`,
  GET_CASE_VARY: (id: string): string => `weapon-licence-cases/vary-form/${id}`,
  CASE_RENEW: (): string => 'weapon-licence-cases/renew',
  CASE_VARY: (): string => 'weapon-licence-cases/vary',
  GET_CASE_WORKERS: (id: string): string => `weapon-licence-cases/${id}/workers`,
  GET_CASE_LICENCES: (id: string): string => `weapon-licence-cases/${id}/licences`,
  GET_APPLICATION_FILES: (id: string): string =>
    `/weapon-licence-cases/${id}/application-files`,
  GET_APPLICATION_FILE_REVIEW: (id: string): string =>
    `weapon-licence-cases/application-files/${id}/review`,
  GET_APPLICATION_COMMENTS: (id: string): string =>
    `weapon-licence-cases/application-files/${id}/review/threads`,
  ADD_APPLICATION_COMMENT: (id: string): string =>
    `weapon-licence-cases/application-files/${id}/review/threads`,
  ADD_APPLICATION_COMMENT_FOR_THREAD: (id: string, threadId: string): string =>
    `weapon-licence-cases/application-files/${id}/review/threads/${threadId}/comments`,
  UPDATE_APPLICATION_COMMENT: (id: string, commentId: string): string =>
    `weapon-licence-cases/application-files/${id}/review/comments/${commentId}`,
  UPDATE_APPLICATION_COMMENT_THREAD: (id: string, threadId: string): string =>
    `weapon-licence-cases/application-files/${id}/review/threads/${threadId}`,
  GET_CASE_THREADS: (id: string): string => `weapon-licence-cases/${id}/threads`,
  ADD_CASE_THREAD: (id: string): string => `weapon-licence-cases/${id}/threads`,
  ADD_CASE_THREAD_COMMENT: (id: string, threadId: string): string =>
    `weapon-licence-cases/${id}/threads/${threadId}/comments`,
  GET_CASE_ATTACHMENTS_FILES: (id: string): string => `weapon-licence-cases/${id}/documents`,
  DOWNLOAD_CASE_ATTACHMENTS_FILES: (id: string, typeId: string): string =>
    `weapon-licence-cases/${id}/documents/${typeId}/download`,
  GET_CASE_NOTES: (id: string): string => `weapon-licence-cases/${id}/notes/search`,
  CREATE_CASE_NOTE: (id: string): string => `weapon-licence-cases/${id}/notes`,
  GET_CASE_NOTE: (noteId: string): string => `weapon-licence-cases/notes/${noteId}`,
  UPDATE_CASE_NOTE: (id: string, noteId: string): string =>
    `weapon-licence-cases/${id}/notes/${noteId}`,
  DELETE_CASE_NOTE: (id: string, noteId: string): string =>
    `weapon-licence-cases/${id}/notes/${noteId}`,
  GET_CASE_HISTORY: (id: string): string => `weapon-licence-cases/${id}/history`,
  GET_CASE_TASKS: (id: string): string => `weapon-licence-cases/${id}/tasks`,
  GET_CASE_TASK: (id: string): string => `weapon-licence-cases/tasks/${id}`,
  CREATE_CASE_TASK: (id: string): string => `weapon-licence-cases/${id}/tasks`,
  CREATE_CASE_TASK_COMMENT: (id: string): string => `weapon-licence-cases/tasks/${id}`,
  DELETE_CASE_TASK: (id: string): string => `weapon-licence-cases/tasks/${id}`,
  GET_CASE_REPORTS: (id: string): string => `weapon-licence-cases/${id}/intelligence-reports`,
  GET_CASE_REPORT: (id: string): string => `weapon-licence-cases/intelligence-reports/${id}`,
  CREATE_CASE_REPORT_RESULT: (id: string): string =>
    `weapon-licence-cases/intelligence-reports/${id}`,
  CREATE_CASE_REPORT: (id: string): string =>
    `weapon-licence-cases/${id}/intelligence-reports`,
  DELETE_CASE_REPORT: (id: string): string =>
    `weapon-licence-cases/intelligence-reports/${id}`,
  GENERATE_CASE_SUMMARY_REPORT: (id: string): string =>
    `weapon-licence-cases/${id}/summary-report/generate`,
  GET_CASE_SUMMARY_REPORT: (id: string): string =>
    `weapon-licence-cases/${id}/summary-report/preview`,
  DOWNLOAD_CASE_SUMMARY_REPORT: (id: string): string =>
    `weapon-licence-cases/${id}/summary-report/download `,
  GET_CASE_OTHER_WORKERS: (): string => `/weapon-licence-cases/other/workers`,
  GET_CASE_OTHER_COMMENTS: (id: string): string => `weapon-licence-cases/other/${id}/comments`,
  CREATE_CASE_OTHER_COMMENT: (id: string): string =>
    `weapon-licence-cases/other/${id}/comments`,
  UPDATE_CASE_REPORT: (id: string): string =>
    `weapon-licence-cases/intelligence-reports/${id}`,
  DOWNLOAD_CASE_ATTACHMENTS_FILE: (id: string): string =>
    `weapon-licence-cases/document/${id}/download`,
  PREVIEW_CASE_ATTACHMENTS_FILE: (id: string): string =>
    `weapon-licence-cases/document/${id}/preview`,
  ASSIGNED_USERS_CASE: (): string => `/weapon-licence-cases/assigned-users`,
  ADD_CASE_ATTACHMENTS_FILES: (): string => `weapon-licence-cases/documents`,
  ADD_CASE_ATTACHMENTS_FILES_NEW_TYPE: (id: string): string =>
    `weapon-licence-cases/${id}/documents`,
  DELETE_CASE_ATTACHMENTS_FILES: (id: string): string =>
    `weapon-licence-cases/documents/${id}`,
  GET_WEAPON_LICENSES_CASES_TEMPLATES_SEARCH: (): string =>
    `weapon-licence-cases/licence-templates/search`,
  CREATE_CASE: () => `weapon-licence-cases`,
  RENEWAL_CASE_STATUS: (id: string) =>
    `/weapon-licence-cases/${id}/renewal-concurrency-status`,
  VARIATION_CASE_STATUS: (id: string) =>
    `/weapon-licence-cases/${id}/variation-concurrency-status`,
  CREATE_OTHER_CASE: () => `weapon-licence-cases/other`,
  GET_CASE_FILE_PREVIEW: (id: string) =>
    `/weapon-licence-cases/application-file/${id}/preview`,
  GET_CASE_FILE_DOWNLOAD: (id: string) =>
    `/weapon-licence-cases/application-file/${id}/download`,
  VERIFICATION_CASE: (id: string) => `weapon-licence-cases/${id}/start-verification`,
  FINISH_VERIFICATION_CASE: (id: string) => `/weapon-licence-cases/${id}/finish-verification`,
  ASSIGN_CASE: (id: string) => `weapon-licence-cases/${id}/assign`,
  REPRINT_CASE_LICENCE: (id: string) => `weapon-licence-cases/${id}/tasks/reprint`,
  CLOSE_CASE: (id: string) => `weapon-licence-cases/${id}/close`,
  CLOSE_TASK: (id: string) => `weapon-licence-cases/other/${id}/close`,
  APPROVE_CASE: (id: string) => `weapon-licence-cases/${id}/approve`,
  REFUSE_CASE: (id: string) => `weapon-licence-cases/${id}/refuse`,
  REJECT_CASE: (id: string) => `weapon-licence-cases/${id}/reject`,
  GET_CASE_DECISION: (id: string) => `weapon-licence-cases/${id}/decision`,
  CASE_UPDATE_PAYMENT: (id: string) => `/weapon-licence-cases/${id}/payment-status`,
  GET_CASE_DASHBOARD: () => 'weapon-licence-cases/dashboard',
  GET_CASE_MANAGEMENT: () => 'weapon-licence-cases/other/search',
  GET_LEGAL_ATTACHMENTS_SEARCH: (): string => 'legal/attachments/search',
  ADD_LEGAL_ENTITY_ATTACHMENT: (id: string): string => `legal/attachments/${id}`,
  GET_LEGAL_ENTITY_ATTACHMENT: (legalUniqueId: string, attachmentUniqueId: string): string =>
    `legal/attachments/${legalUniqueId}/${attachmentUniqueId}`,
  PREVIEW_LEGAL_ENTITY_ATTACHMENT: (
    legalUniqueId: string,
    attachmentUniqueId: string,
  ): string => `legal/attachments/${legalUniqueId}/preview/${attachmentUniqueId}`,
  DOWNLOAD_LEGAL_ENTITY_ATTACHMENT: (
    legalUniqueId: string,
    attachmentUniqueId: string,
  ): string => `legal/attachments/${legalUniqueId}/download/${attachmentUniqueId}`,
  DELETE_LEGAL_ENTITY_ATTACHMENT: (
    legalUniqueId: string,
    attachmentUniqueId: string,
  ): string => `legal/attachments/${legalUniqueId}/${attachmentUniqueId}`,
  GET_GALLERY_OWNER: (ownerObjectId: string) => `gallery/${ownerObjectId}`,
  GET_GALLERY_SPECIALIZED_OWNER: (ownerObjectId: string) =>
    `gallery/specialized/${ownerObjectId}`,
  GET_GALLERY_OWNER_FILES: (ownerObjectId: string) => `gallery/${ownerObjectId}/with-urls`,
  GET_GALLERY_PREVIEW: (entryId: string) => `/gallery/preview/${entryId}`,
  GET_GALLERY_MAIN_OWNER: (ownerObjectId: string) => `gallery/main/${ownerObjectId}`,
  GET_GALLERY_MAIN_PREVIEW: (ownerObjectId: string) => `gallery/preview/main/${ownerObjectId}`,
  UPDATE_GALLERY_OWNER: (id: string) => `gallery/${id}`,
  VALIDATE_GALLERY_IMAGE: () => 'gallery/validate',
  DOWNLOAD_GALLERY_PREVIEW: (entryId: string) => `gallery/download/${entryId}`,
  GET_LICENSES_AUTHORITIES: () => `licence-authority/search`,
  GET_LICENSES_AUTHORITY: (id: string) => `licence-authority/${id}`,
  GET_LICENSES_AUTHORITY_SFTP_SEND_STATE: (id: string) =>
    `licence-authority/${id}/sftp/send-state`,
  CREATE_LICENSES_AUTHORITY: () => `licence-authority`,
  UPDATE_LICENSES_AUTHORITY: (id: string) => `licence-authority/${id}`,
  CREATE_LICENSES_AUTHORITY_SIGNATUE: () => `licence-authority/signatures`,
  CREATE_LICENSES_PRINTOUT_SETTINGS: (id: string) => `licence-authority/${id}/sftp/initialize`,
  UPDATE_LICENSES_PRINTOUT_SETTINGS: (id: string) => `licence-authority/${id}/sftp`,
  DELETE_LICENSES_PRINTOUT_SETTINGS: (id: string) => `licence-authority/${id}/sftp`,
  GET_LICENSE_AUTHORITY_PRINTOUT_ERROR_LOG_DATA: (id: string) =>
    `licence-authority/${id}/sftp/alerts`,
  RESOLVE_LICENSE_AUTHORITY_PRINTOUT_ERROR_LOG_DATA: (id: string, alertId: string) =>
    `licence-authority/${id}/sftp/alerts/${alertId}/resolve`,
  GET_LICENCE_AUTHORITY_SFTP_ALERT_STATUS: (id: string) =>
    `licence-authority/${id}/sftp/alert-status`,
  ROTATE_PGP_KEY_LICENSES_PRINTOUT_SETTINGS: (id: string) =>
    `licence-authority/${id}/sftp/rotate/pgp`,
  ROTATE_SSH_KEY_LICENSES_PRINTOUT_SETTINGS: (id: string) =>
    `licence-authority/${id}/sftp/rotate/ssh`,
  READ_LICENSES_PRINTOUT_DELETION_INFO: (id: string) =>
    `licence-authority/${id}/sftp/deletion-info`,
  GET_LICENSES_PRINTOUT_SETTINGS: (id: string) => `licence-authority/${id}/sftp`,
  VALIDATE_LICENSES_AUTHORITY_SIGNATUE: () => `licence-authority/signature/validate`,
  RESUME_SENDING_LICENCE_AUTHORITY_PRINTOUT_SETTINGS: (id: string) =>
    `licence-authority/${id}/sftp/send-state/resume`,
};
